// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featureMapMarkerContainer {
  position: absolute;
  display: flex !important;
  text-shadow: none;
  user-select: none;
  -webkit-user-select: none;
  z-index: 0;
  width: 30px;
  height: 30px;
  overflow: visible;
  box-sizing: border-box;
  /** Add arrow under box **/
}
.featureMapMarkerContainer .featureMapMarker {
  position: absolute;
  display: flex;
  width: 30px;
  height: 30px;
  margin: auto;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.219);
  user-select: none;
  -webkit-user-select: none;
  font-family: Gothic;
}
.featureMapMarkerContainer .featureMapMarker.openMarker {
  opacity: 1;
}
.featureMapMarkerContainer .featureMapMarker.closeMarker {
  opacity: 0;
}
.featureMapMarkerContainer .openMarker .featureContent {
  transition: 350ms;
  opacity: 1;
  transform: translateY(-45px);
}
.featureMapMarkerContainer .closeMarker .featureContent {
  transition: 250ms;
  opacity: 0;
  transform: translateY(-25px);
}
.featureMapMarkerContainer .featureContent {
  background-color: rgba(36, 36, 36, 0.9098039216);
  position: absolute;
  display: flex;
  flex: 1 1 auto;
  margin: auto;
  align-items: center;
  border-radius: 2px;
  min-width: 250px;
  max-width: 600px;
  flex-basis: auto;
  padding: 8px;
  top: -40px;
  opacity: 1;
  justify-content: left;
  color: white;
  overflow: visible;
}
.featureMapMarkerContainer .featureContent h4 {
  display: block;
  font-size: 1.4em;
  margin-bottom: 1px;
  margin-top: 4px;
}
.featureMapMarkerContainer .featureContent .place-name {
  display: flex;
  font-size: 1.2em;
  flex-basis: auto;
}
.featureMapMarkerContainer .featureContent:after, .featureMapMarkerContainer .featureContent:before {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.featureMapMarkerContainer .featureContent:after {
  border-color: rgba(255, 255, 255, 0);
  border-top-color: rgba(36, 36, 36, 0.5019607843);
  border-width: 14px;
  margin-left: -14px;
}
.featureMapMarkerContainer .featureContent:before {
  border-color: transparent;
  border-top-color: rgba(255, 255, 255, 0);
  border-width: 14px;
  margin-left: -14px;
}
.featureMapMarkerContainer .featureContent.search-result {
  top: -56px;
  padding-left: 14px;
}
.featureMapMarkerContainer .svg-icon {
  font-size: 27px;
  line-height: 24px;
  vertical-align: bottom;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/feature-map-marker/feature-map-marker.component.scss"],"names":[],"mappings":"AAIA;EACI,kBAAA;EACA,wBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,WATU;EAUV,YAVU;EAWV,iBAAA;EACA,sBAAA;EAsEA,0BAAA;AAxEJ;AAII;EACI,kBAAA;EACA,aAAA;EACA,WAjBM;EAkBN,YAlBM;EAmBN,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAFR;AAKI;EACI,UAAA;AAHR;AAMI;EACI,UAAA;AAJR;AAOI;EACI,iBAAA;EACA,UAAA;EACA,4BAAA;AALR;AAQI;EACI,iBAAA;EACA,UAAA;EACA,4BAAA;AANR;AASI;EACI,gDAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AAPR;AASQ;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAPZ;AAUQ;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;AARZ;AAcI;EACI,SAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AAZR;AAeI;EACI,oCAAA;EACA,gDAAA;EACA,kBAAA;EACA,kBAAA;AAbR;AAeI;EACI,yBAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;AAbR;AAgBI;EACI,UAAA;EACA,kBAAA;AAdR;AAiBI;EACI,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AAfR","sourcesContent":["// OBS: We cant contain this in component selector as only part of the dom is inserted as mapbox marker\n\n$marker-size: 30px;\n\n.featureMapMarkerContainer  {\n    position: absolute;\n    display: flex !important;\n    text-shadow: none;\n    user-select: none;\n    -webkit-user-select: none;\n    z-index: 0;\n    width: $marker-size;\n    height: $marker-size;\n    overflow: visible;\n    box-sizing: border-box;\n    \n    .featureMapMarker {\n        position:absolute;\n        display:flex;\n        width: $marker-size;\n        height: $marker-size;\n        margin: auto;\n        border-radius: 100%;\n        justify-content: center;\n        align-items: center;\n        background-color: rgba(255, 255, 255, 0.219);\n        user-select: none;\n        -webkit-user-select: none;\n        font-family: Gothic;\n    }\n    \n    .featureMapMarker.openMarker {\n        opacity: 1;\n    }\n    \n    .featureMapMarker.closeMarker {\n        opacity: 0;\n    }\n\n    .openMarker .featureContent {\n        transition: 350ms;\n        opacity: 1;\n        transform: translateY(-45px);\n    }\n    \n    .closeMarker .featureContent {\n        transition: 250ms;\n        opacity: 0;\n        transform: translateY(-25px);\n    }\n\n    .featureContent {\n        background-color: #242424e8;\n        position: absolute;\n        display: flex;\n        flex: 1 1 auto;\n        margin: auto;\n        align-items: center;\n        border-radius: 2px;\n        min-width: 250px;\n        max-width: 600px;\n        flex-basis: auto;\n        padding: 8px;\n        top: -(($marker-size) + 10);\n        opacity: 1;\n        justify-content: left;\n        color: white;\n        overflow: visible;\n        \n        h4 {\n            display: block;\n            font-size: 1.4em;\n            margin-bottom: 1px;\n            margin-top: 4px;\n        }\n        \n        .place-name {\n            display: flex;\n            font-size: 1.2em;\n            flex-basis: auto;\n        }\n        \n    }\n    \n    /** Add arrow under box **/\n    .featureContent:after, .featureContent:before {\n        top: 100%;\n        left: 50%;\n        border: solid transparent;\n        content: \" \";\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n    }\n    \n    .featureContent:after {\n        border-color: #ffffff00; // Border color of arrow\n        border-top-color: #24242480; // Background color\n        border-width: 14px;\n        margin-left: -14px;\n    }\n    .featureContent:before {\n        border-color: transparent;\n        border-top-color: #ffffff00; // Border color of arrow\n        border-width: 14px;\n        margin-left: -14px;\n    }\n    \n    .featureContent.search-result {\n        top: -56px;\n        padding-left: 14px;\n    }\n\n    .svg-icon {\n        font-size: 27px;\n        line-height: 24px;\n        vertical-align: bottom;\n        margin-right: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
